import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),

        dateFilter() {
            return {
                since: this.startDate,
                until: this.endDate,
            };
        },

        reportCustomFilters() {
            return ['outlet_id', 'since', 'until'];
        },
    },

    watch: {
        activeOutlet(newVal, oldVal) {
            this.$emit('outlet-changed', newVal);
        },

        dateFilter(newVal) {
            this.$emit('date-changed', newVal);
        },
    },

    methods: {
        registerReportFilterEvent() {
            this.$on('outlet-changed', outlet_id => {
                this.applyOutletFilter(outlet_id);
            });

            this.$on('date-changed', date => {
                if (this.loading) return;

                this.applyDateFilter(date);
            });
        },

        applyDateFilter(date) {
            this.customQueries.since =
                date.since !== null ? date.since.format() : null;

            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'until',
                value: date.until !== null ? date.until.format() : null,
            });
        },

        applyOutletFilter(outlet_id) {
            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: outlet_id,
            });
        },

        getInitialFilterValue(filter) {
            const startDate = this.$store.getters.startDate;
            const endDate = this.$store.getters.endDate;

            if (filter === 'outlet_id') {
                return this.$store.getters.activeOutlet;
            } else if (filter === 'since') {
                if (startDate !== null) return startDate.format();

                return startDate;
            } else if (filter === 'until') {
                if (endDate !== null) return endDate.format();

                return endDate;
            }

            return null;
        },

        initReportCustomFilters() {
            this.reportCustomFilters.forEach(filter => {
                this.customQueries[filter] = this.getInitialFilterValue(filter);
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mixins/report.js